import { createApiClient } from '@betstarters/api'

// Single shared axios instance used by the AuthProvider and any component
// that needs to call the backoffice API directly (e.g. the shared LoginPage
// and ProfilePage from @betstarters/ui, which expect an `api` prop).
export const api = createApiClient({
  baseURL: `${import.meta.env.VITE_API_URL || ''}/api/v1`,
})
